import React, { Component } from "react";
import QuoteStepBase, { mapDriverStepProps } from '../components/QuoteStepBase'
import Question from '../components/Question'
import { Modal } from 'react-bootstrap'
import ButtonContinue from "../components/ButtonContinue";
import { IDriverStepProps, IQuoteStepState } from "../components/interfaces";
import { QUOTE_STEPS, COMPONENTS, QUOTE_QUESTIONS, MARIED_TYPES } from "../AppConstants";
import { connect } from "react-redux";
import { validationUtils } from "../validation/Validation";
import QuoteStep from "./QuoteStepLayout";
import { ValidatableForm } from "../components/ValidatableForm";
import { ValidatableFormGroup } from "../components/ValidatableFormGroup";
import Utilities from "../classes/Utilities";
import { IQuoteApiClient, IPaths, IToolTipOption, IDriver } from "../classes/Domain";
import QuoteActions from "../state/appActions";
import { IAppState } from "../state/interfaces";


interface IState extends IQuoteStepState {
    validLicense: string,
    licenseState: string,
    licenseYears: string,
    showMoreOptionsForm: boolean,
    moreOptionsFormDisplayed: boolean;
}

export interface IProps extends IDriverStepProps {
    insured: IDriver,
    quoteApiClient: IQuoteApiClient,
    PATHS: IPaths;
}

export const mapDriverLicenseState = (licenseState: string) => {
    let _licenseState = "";

    switch (licenseState) {
        case "TX":
            _licenseState = QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATE.TEXAS;
            break;
        case "CA":
            _licenseState = QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATE.CALIFORNIA;
            break;
        case "MX":
            _licenseState = QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATE.MEXICO;
            break;
        case QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATE.TEXAS:
            _licenseState = "TX";
            break;
        case QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATE.CALIFORNIA:
            _licenseState = "CA";
            break;
        case QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATE.MEXICO:
            _licenseState = "MX";
            break;
        case QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATE.OTHER_US_STATE:
            _licenseState = "AK";
            break;
        case "":
            break;
        default:
            _licenseState = QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATE.OTHER_US_STATE;
            break;
    }

    return _licenseState;
};

class YourLicense extends QuoteStepBase<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.next = this.next.bind(this);
        this.openMoreOptionsForm = this.openMoreOptionsForm.bind(this);
        this.handleGetMoreOptions = this.handleGetMoreOptions.bind(this);
        this.handleCloseMoreOptionsForm = this.handleCloseMoreOptionsForm.bind(this);

        this.state = {
            validLicense: "",
            licenseState: "",
            licenseYears : "16",
            updatingStore: false,
            moreOptionsFormDisplayed: false,
            showMoreOptionsForm: false,
            errors: null
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const driver = nextProps.driver;
            nextProps.meta.propsSource = "";

            if (null === driver) return prevState;



            return {
                ...prevState,
                validLicense: !!driver.validLicense ? driver.validLicense : "",
                licenseState: !!driver.licenseState ? mapDriverLicenseState(driver.licenseState) : "",
                visibleCurrentStatus: !!driver.validLicense ? driver.validLicense === QUOTE_QUESTIONS.YES_NO.NO : false,
                licenseYears: !!driver.licenseYears ? driver.licenseYears : "16",
                driverTrainingClasses: driver.driverTrainingClasses
            };
        }

        return prevState;
    }

    next(event : React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        event.preventDefault();

        this.setState({ updatingStore: true }, () => {
            const updatedDriver = {
                ...this.props.driver,
                validLicense: this.state.validLicense,
                licenseYears: this.state.licenseYears,
                licenseState: mapDriverLicenseState(this.state.licenseState)
            };

            this.props.updateAppState({ quoteUid: this.props.quoteUid, driver: updatedDriver })
                .then(() => this.props.history.push(Utilities.formatUrl(this.props.PATHS.DRIVING_HISTORY, (0 < this.props.driverIndex ? this.props.driverIndex + "" : ""))),
                    () => {
                        this.setState({ ...this.state, updatingStore: false });
                    });
        });
    }


    callbackFunctionLicense = (childData:string) => {
        switch (childData) {
            case QUOTE_QUESTIONS.YES_NO.YES:
                this.setState({ validLicense: childData });
                break;
            case QUOTE_QUESTIONS.YES_NO.NO:
                if (!this.state.showMoreOptionsForm) {
                    this.openMoreOptionsForm();
                    this.setState({ validLicense: childData });
                }
                break;
        }
    };

    callbackFunctionLicenseState = (childData: string) => {
        switch (childData) {
            case QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATE.OTHER:
                if (!this.state.showMoreOptionsForm) {
                    this.openMoreOptionsForm();
                    this.setState({ licenseState: childData });
                }
                break;
            default:
                this.setState({ licenseState: childData });
                break;
        }
    };

    openMoreOptionsForm() {
        this.setState({ ...this.state, showMoreOptionsForm: true, moreOptionsFormDisplayed: true });
    }

    handleCloseMoreOptionsForm() {
        this.setState({ ...this.state, showMoreOptionsForm: false });
    }

    handleGetMoreOptions() {
        this.handleCloseMoreOptionsForm();
    }

    getDescription() {
        let drNumber = this.props.driverIndex + 1;

        if (this.props.driverIndex == 0) {
            return "YOUR LICENSE";
        }
        else if (this.props.driverIndex == 1 && MARIED_TYPES.includes(this.props.insured.maritalStatus)) {
            return 'YOUR SPOUSE (' + this.props.driver.firstName + ' ' + this.props.driver.lastName + ') LICENSE';
        }
        else {
            return 'DRIVER #'+ drNumber + ' (' + this.props.driver.firstName + ' ' + this.props.driver.lastName + ') LICENSE';
        }
    }

    render() {
        return (
            <QuoteStep id={this.props.id}>
                <div className="titleArea"><h5>{this.getDescription()}</h5></div>
                <ValidatableForm hasErrors={null != this.state.errors}>
                    <Question
                        name="validLicense"
                        selected={this.callbackFunctionLicense}
                        selectedValue={this.state.validLicense}
                        error={validationUtils.getValidationErrorFor(this.state.errors, "validLicense")}
                        items={[
                            QUOTE_QUESTIONS.YES_NO.YES,
                            QUOTE_QUESTIONS.YES_NO.NO
                        ]}
                        lable={this.props.driverIndex == 0
                            ? 'Do you (' + this.props.driver.firstName + ' ' + this.props.driver.lastName + ') have an active driver`s license?'
                            : 'Does ' + this.props.driver.firstName.toUpperCase() + ' ' + this.props.driver.lastName.toUpperCase() + ' have an active driver`s License?'}
                        tooltip={{ title: "Info", content: "We can still help you if you do not have an active license.  Please give us a call at 424 559-5751." } as IToolTipOption}
                    />

                    {
                        this.props.stateCode === "CA"
                            ?
                            <Question
                                name="licenseState"
                                error={validationUtils.getValidationErrorFor(this.state.errors, "licenseState")}
                                selected={this.callbackFunctionLicenseState}
                                selectedValue={this.state.licenseState}
                                style={{ display: this.state.validLicense === QUOTE_QUESTIONS.YES_NO.YES ? '' : 'none' }}
                                items={[
                                    QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATE.CALIFORNIA,
                                    QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATE.OTHER_US_STATE,
                                    QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATE.MEXICO,
                                    QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATE.OTHER
                                ]}
                                lable="Please specify the driver`s license state"
                                tooltip={{ title: "Info", content: "We can still help you. Please give us a call at 424 559-5751." } as IToolTipOption}
                            />
                            : null
                    }

                    {
                        this.props.stateCode === "TX"
                            ?
                            <Question
                                name="licenseState"
                                error={validationUtils.getValidationErrorFor(this.state.errors, "licenseState")}
                                selected={this.callbackFunctionLicenseState}
                                selectedValue={this.state.licenseState}
                                style={{ display: this.state.validLicense === QUOTE_QUESTIONS.YES_NO.YES ? '' : 'none' }}
                                items={[
                                    QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATE.TEXAS,
                                    QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATE.OTHER_US_STATE,
                                    QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATE.MEXICO,
                                    QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATE.OTHER
                                ]}
                                lable="Please specify the driver`s license state"
                                tooltip={{ title: "Info", content: "We can still help you. Please give us a call at 424 559-5751." } as IToolTipOption}
                            />
                            : null
                    }

                    <div>
                        <ValidatableFormGroup
                            label={this.props.driverIndex == 0
                                ? "How old were you when you first got your license in the U.S. or Canada?"
                                : 'How old were ' + this.props.driver.firstName.toUpperCase() + ' ' + this.props.driver.lastName.toUpperCase() + ' when first got license in the U.S. or Canada?'}
                            maxLength={2}
                            value={this.state.licenseYears}
                            validated={null !== this.state.errors}
                            validationError={validationUtils.getValidationErrorFor(this.state.errors, "licenseYears")}
                            onChange={(e) => { this.setStateValue(e.target.value, "licenseYears") }}
                            pattern="[0-9]*"
                            inputmode= "numeric" />
                    </div>

                </ValidatableForm>

                <div className="btnContainer">
                    <ButtonContinue
                        disabled={this.state.updatingStore || this.state.validLicense === QUOTE_QUESTIONS.YES_NO.NO || this.state.licenseState === QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATE.OTHER}
                        showLoading={this.state.updatingStore}
                        onClick={this.next} />
                </div>

                <Modal show={this.state.showMoreOptionsForm} onHide={this.handleCloseMoreOptionsForm}>
                    <Modal.Header closeButton>
                        <Modal.Title>Info</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="text-center font-weight-bolder">
                            Please call us at
                        </p>
                        <div className="text-center">
                            <a href={"tel:(424)559-5751"} className="btnContinue btn btn-primary btn-sm for-mobile">Call Us <i className="fas fa-phone"></i></a>
                            <span className="big-label text-center for-desktop">(424)559-5751</span>
                        </div>
                        <p className="text-center font-weight-bolder">
                            or email us at <a href="mailto:Onward_Sales@onwardins.com">Onward_Sales@onwardins.com</a>
                        </p>
                        <p className="text-center font-weight-bolder">
                            for customized coverage
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <ButtonContinue
                            className="btn-sm"
                            disabled={this.state.updatingStore}
                            label="Close"
                            showLoading={this.state.updatingStore}
                            onClick={this.handleGetMoreOptions} />
                    </Modal.Footer>
                </Modal>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IDriverStepProps) => {
    var driverIndex = !ownProps.match.params["driverIndex"]
        ? 0
        : parseInt(ownProps.match.params["driverIndex"], 10);

    return {
        quoteUid: state.quoteUid,
        driverIndex: driverIndex,
        insured: driverIndex > 0 ? state.drivers[0] : null,
        driversCount: state.drivers.length,
        driver: driverIndex < state.drivers.length ? state.drivers[driverIndex] : null,
        secondDriver: state.drivers.length >= 2 && driverIndex == 0 ? state.drivers[1] : null,
        meta: { propsSource: COMPONENTS.PROPS_SOURCES.APP_STORE },
        stateCode: state.stateCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(QUOTE_STEPS.YOUR_LICENSE)),
        updateAppState: (update) => dispatch(quoteActions.updateDriver(update.quoteUid, update.driver, QUOTE_STEPS.YOUR_LICENSE))
    };
};

export default connect(mapProps, mapDispatch)(YourLicense);
